__turbopack_context__.v({
  "default": "NQvU4a_default",
  "fill": "NQvU4a_fill",
  "img": "NQvU4a_img",
});
